import { Routes as RouterRoutes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import AppShellPage from './pages/AppShellPage';

function LegacyAuthRedirect() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isSignup = location.pathname === '/signup';
  const mode = searchParams.get('mode') || (isSignup ? 'signup' : 'login');
  const returnTo = searchParams.get('returnTo') || '/app';
  const resetToken = searchParams.get('reset_token');
  const params = new URLSearchParams({ panel: 'auth', mode, returnTo });
  if (resetToken) params.set('reset_token', resetToken);
  return <Navigate to={`/app?${params.toString()}`} replace />;
}

function LegacyPanelRedirect({ panel }) {
  return <Navigate to={`/app?panel=${panel}`} replace />;
}

function RootScene() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (location.pathname === '/' && !searchParams.get('panel')) {
    return <AppShellPage />;
  }
  return <AppShellPage />;
}

export default function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<RootScene />} />
      <Route path="/app" element={<AppShellPage />} />
      <Route path="/app/s/:sessionId" element={<AppShellPage />} />
      <Route path="/login" element={<LegacyAuthRedirect />} />
      <Route path="/signup" element={<LegacyAuthRedirect />} />
      <Route path="/app/settings/billing" element={<LegacyPanelRedirect panel="billing" />} />
      <Route path="/dashboard" element={<Navigate to="/app" replace />} />
      <Route path="/dashboard/created-tickets" element={<LegacyPanelRedirect panel="tickets" />} />
      <Route path="/dashboard/settings" element={<LegacyPanelRedirect panel="integrations" />} />
      <Route path="/context-selection" element={<Navigate to="/app" replace />} />
      <Route path="/ticket-review/:sessionId" element={<Navigate to="/app" replace />} />
      <Route path="/created-tickets" element={<LegacyPanelRedirect panel="tickets" />} />
      <Route path="/settings" element={<LegacyPanelRedirect panel="integrations" />} />
    </RouterRoutes>
  );
}
